import aT from '../const/action-type'

export default (data) => {
  return { type: aT.SET_AVAILABILITIES, data }
}
